import gql from 'graphql-tag';

const GET_PRICESHEETS = gql`
 query pricesheets {
    pricesheets: getPricesheets {
      id,
      label,
      baseMarkup,
      scope,
      scopeId,
      products {
          price
          product {
              id,
              inRutaCode,
              inRutaShortDescriptionSpanish
          }
      }
    }
  }
`;

export default GET_PRICESHEETS;
